import React, { useMemo } from 'react'
import { Row, Col, Tag, Typography, Space } from 'antd'

const { Title } = Typography

const DEFAULT_COLORS = {
    Pass: '#52c41a', // green
    Pending: '#faad14', // orange
    Retest: '#1890ff', // blue
    Fail: '#db2114', // red
}

function formatPercentage(value) {
    const num = Number(value)
    if (!isFinite(num)) return '0'
    return Number.isInteger(num) ? String(num) : num.toFixed(2)
}

const ReportStats = ({ data = [], colorMap = DEFAULT_COLORS }) => {
    // Normalize & index by status for quick lookup
    const byStatus = useMemo(() => {
        const map = new Map()
        ;(data || []).forEach((d) => {
            if (!d || typeof d !== 'object') return
            const status = String(d.status ?? '').trim()
            if (!status) return
            map.set(status, {
                status,
                count: Number(d.count ?? 0),
                percentage: Number(d.percentage ?? 0),
            })
        })
        return map
    }, [data])

    // Extract "Pass" safely
    const pass = byStatus.get('Pass') || {
        status: 'Pass',
        count: 0,
        percentage: 0,
    }
    const passColor = colorMap['Pass'] || '#52c41a'

    // For second row: keep the same input order
    const items = (data || [])
        .map((d) => ({
            status: String(d?.status ?? '').trim(),
            count: Number(d?.count ?? 0),
            percentage: Number(d?.percentage ?? 0),
        }))
        .filter((d) => d.status)

    return (
        // <Card bordered style={{ width: '100%' }}>
        <Row gutter={[12, 16]}>
            {/* Row 1: PASS highlight */}
            <Col span={24}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                    }}
                >
                    <Title
                        level={3}
                        style={{
                            margin: 0,
                            color: passColor,
                            fontWeight: 700,
                        }}
                    >
                        Pass :
                    </Title>
                    <Title
                        level={2}
                        style={{
                            margin: 0,
                            color: passColor,
                            fontWeight: 700,
                        }}
                    >
                        {`${formatPercentage(pass?.percentage)}%`}
                    </Title>
                </div>
                {/* <Text type="secondary">
                    {`Count: ${pass.count}`}
                </Text> */}
            </Col>

            {/* Row 2: All statuses with colors */}
            <Col span={24}>
                <Space wrap size={[8, 12]} style={{ width: '100%' }}>
                    {items.map((it) => {
                        const color = colorMap[it.status] || '#d9d9d9'
                        const isZero = !it.count && !it.percentage
                        return (
                            <Tag
                                key={it.status}
                                color={color}
                                style={{
                                    padding: '6px 10px',
                                    borderRadius: 999,
                                    fontWeight: 600,
                                    opacity: isZero ? 0.7 : 1,
                                }}
                            >
                                <span style={{ fontWeight: 700 }}>
                                    {it.status}
                                </span>
                                <span style={{ fontWeight: 400 }}>
                                    {` - ${it.count} (${formatPercentage(
                                        it.percentage
                                    )}%)`}
                                </span>
                            </Tag>
                        )
                    })}
                </Space>
            </Col>
        </Row>
        // </Card>
    )
}

export default ReportStats
